
import React from 'react';
import './ToolsSection.css';

const ToolIcon = () => (
  <div className="tool-icon">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="4" width="16" height="16" rx="3" />
      <path d="M8 9h8M8 13h5" />
    </svg>
  </div>
);

const ToolsSection = () => {
  const tools = [
    {
      title: 'Quote Me',
      description: 'Generate instant quotes and share them directly with your clients.'
    },
    {
      title: 'Samples Box',
      description: 'Request curated material samples delivered straight to your studio.'
    },
    {
      title: 'Material Packages',
      description: 'Bundle frequently used materials into ready-to-order packages.'
    },
    {
      title: 'MIO Floor Plan',
      description: 'Create and manage detailed floor plans for every project.'
    },
    {
      title: 'Connect with Owner',
      description: 'Collaborate with homeowners and stakeholders in one workspace.'
    },
    {
      title: 'Shoot My Site',
      description: 'Schedule professional photography for completed projects.'
    }
  ];

  return (
    <section className="tools-section">
      <div className="tools-container">
        <h2 className="tools-title">Important Tools</h2>
        <div className="tools-grid">
          {tools.map((tool, index) => (
            <div key={index} className="tool-card">
              <ToolIcon />
              <div className="tool-content">
                <h3 className="tool-title">{tool.title}</h3>
                <p className="tool-description">{tool.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ToolsSection;
